import { Mail, MapPin, Phone } from 'lucide-react';
import { Typography } from '../Typography';
import { FormattedMessage } from 'react-intl';
import {
  CONTACT_EMAIL,
  CONTACT_PHONE,
  CONTACT_PHONE_FORMATTED,
} from '@/shared/constants/common.ts';

export const Contacts = () => {
  return (
    <ul className="flex-col-gap-4">
      <li className="flex-gap-4 items-center">
        <MapPin strokeWidth={1} />
        <div className="flex-col-gap-0">
          <Typography>
            <FormattedMessage defaultMessage="г. Алматы" />
          </Typography>
          <Typography>
            <FormattedMessage defaultMessage="ул. Тимирязева, 42" />
          </Typography>
        </div>
      </li>
      <li className="flex-gap-4 items-center">
        <Mail strokeWidth={1} />
        <a id="email-link" href={`mailto:${CONTACT_EMAIL}`}>
          {CONTACT_EMAIL}
        </a>
      </li>
      <li className="flex-gap-4 items-center">
        <Phone strokeWidth={1} />
        <a id="phone-link" href={`tel:${CONTACT_PHONE}`}>
          {CONTACT_PHONE_FORMATTED}
        </a>
      </li>
    </ul>
  );
};
